<template>
    <vertical-form-table  v-model="form" v-bind="{ mode, items }" @input="emit">
        <template slot="비밀번호 확인">
            <v-password-confirm-field :password="form.password" outlined />
        </template>
        <template slot="연락처">
            <user-contact-certification v-model="form.phone" outlined dense :btnAttrs="{ color: 'primary', width: 100, height: 50, className: 'mt-n8' }" @change="emit" />
        </template>
    </vertical-form-table>
</template>

<script>
import { rules, USER_TYPES } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import VPasswordConfirmField from "@/components/plugins/vuetify/v-password-confirm-field.vue";
import UserContactCertification from "@/components/dumb/user-contact-certification.vue";

const { COMPANY } = USER_TYPES;

export default {
    components: {
        VerticalFormTable,
        VPasswordConfirmField,
        UserContactCertification,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // form
        mode: { type: String, default: "view" },
    },
    data: () => ({
        form: {},

        rules,
        COMPANY,
    }),
    computed: {
        items() {
            let items = [];
            items.push({
                key: "username",
                term: "아이디",
                type: "text",
                disabled: true,
                required: true,
                placeholder: "아이디를 입력하세요",
                rules: rules.username,
            });
            if (this.mode == "form")
                items.push({
                    key: "password",
                    term: "비밀번호",
                    type: "password",
                    required: true,
                    placeholder: "비밀번호를 입력하세요",
                    rules: rules.password,
                });
            if (this.mode == "form")
                items.push({
                    key: "password",
                    term: "비밀번호 확인",
                    required: true,
                });
            items.push({
                key: "phone",
                term: "연락처",
                required: true,
            });
            return items.map((item) => ({ ...item, outlined: true }));
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
};
</script>

<style>
</style>